<template>
  <modal :modal-key="'score_description'" :class-style="returnCorrectStyle" :body-style="'bottom-padding'" :footer_style="'footer_buttons'"
         @close="$emit('close')">
    <template slot="header">
      <h1 v-if="(getGameDescriptionDetails.home && (getGameDescriptionDetails.homeScore > getGameDescriptionDetails.awayScore)) ||
           (!getGameDescriptionDetails.home && (getGameDescriptionDetails.homeScore < getGameDescriptionDetails.awayScore))">
        {{ getTranslations.home_modals_score_description_congratz
        }}<br>{{ getTranslations.home_modals_score_description_you_won_the_game }}</h1>
      <h1 v-else>{{ getTranslations.home_modals_score_description_too_bad
        }}<br>{{ getTranslations.home_modals_score_description_you_lost_the_game }}</h1>
      <ul>
        <li v-if="getGameDescriptionDetails.home">
          <img :src="userDetails.avatar" alt="">
          <span class="name">{{ userDetails.username }}</span>
        </li>
        <li v-else>
          <img :src="getOpponentDetails.avatar" alt="">
          <span class="name">{{ getOpponentDetails.opponentName }}</span>
          <div class="postgame_user">
            <star v-if="true" :action-on-click="markFavorite" :is-checked="isFavorite(getOpponentDetails.opponentName)"
                  :key-id="_uid"/>
          </div>
        </li>
        <li class="trophy">
          <img src="static/images/trophy.png" alt="">
          <div class="score"><span>{{ getGameDescriptionDetails.homeScore
                }}</span>-<span>{{ getGameDescriptionDetails.awayScore }}</span></div>
        </li>
        <li v-if="getGameDescriptionDetails.home">
          <img :src="getOpponentDetails.avatar" alt="">
          <span class="name">{{ getOpponentDetails.opponentName }}</span>
          <div class="postgame_user">
            <star v-if="true" :action-on-click="markFavorite" :is-checked="isFavorite(getOpponentDetails.opponentName)"
                  :key-id="_uid"/>
          </div>
        </li>
        <li v-else>
          <img :src="userDetails.avatar" alt="">
          <span class="name">{{ userDetails.username }}</span>
        </li>
      </ul>
    </template>
    <template slot="body">
      <h3>{{ getTranslations.home_modals_score_description_result_per_round }}</h3>
      <ul class="rounds_score" v-if="getGameDescriptionDetails.home">
        <li v-for="(roundDetail, index) in roundDetails" :key="index"
            :class="[ (roundDetail.isWinner && getGameDescriptionDetails.home || (!roundDetail.isWinner && !getGameDescriptionDetails.home)) ? '' : 'red' ]">
          <img :src="roundDetail.roundTheme.iconUrl" alt="">
          <span>{{ roundDetail.homeScore }}-{{ roundDetail.awayScore }}</span>
        </li>
      </ul>
      <ul class="rounds_score" v-else>
        <li v-for="(roundDetail, index) in roundDetails" :key="index"
            :class="[ (roundDetail.isWinner && getGameDescriptionDetails.home || (!roundDetail.isWinner && !getGameDescriptionDetails.home)) ? '' : 'red' ]">
          <img :src="roundDetail.roundTheme.iconUrl" alt="">
          <span>{{ roundDetail.homeScore }}-{{ roundDetail.awayScore }}</span>
        </li>
      </ul>
      <h3>{{ getTranslations.home_modals_score_description_points_earned }}</h3>
      <ul class="buttons">
        <li><span class="score-lbl">{{ getGameDescriptionDetails.questionPoints }}</span><span
          class="title">{{ getTranslations.home_modals_score_description_correct_answers }}</span></li>
        <li><span class="score-lbl" style="background: #609f94">{{ getGameDescriptionDetails.roundPoints
              }}</span><span class="title">{{ getTranslations.home_modals_score_description_round_victory }}</span></li>
        <li><span class="score-lbl" style="background: #aa4225">{{ getGameDescriptionDetails.gamePoints
              }}</span><span class="title">{{ getTranslations.home_modals_score_description_game_victory }}</span></li>
        <li><span class="score-lbl" style="background: #16a085">{{ getGameDescriptionDetails.totalPoints
              }}</span><span class="title">{{ getTranslations.home_modals_score_description_total_earned }}</span></li>
      </ul>
    </template>
    <template slot="footer">
       <a style="cursor:pointer" class="btn2 btn2--small btn2--std" @click.prevent="playGameMethod">{{ getTranslations.home_home_new_game }}</a>
    </template>
  </modal>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import Star from '@/components/home/shared/Star';
import Modal from '@/components/home/modals/shared/GenericModal';
import { ChecksToStartNewGame } from '@/common/mixins/rematch/rematch';

export default {
  name: 'score-description',
  mixins: [ChecksToStartNewGame],
  components: {
    Star,
    Modal,
  },
  methods: {
    ...mapActions('users', [
      'markFavoriteUser',
    ]),
    markFavorite() {
      this.markFavoriteUser(this.getGameDescriptionDetails.home ? this.getOpponentDetails.opponentName : this.userDetails.username);
    },
    isFavorite(username) {
      return (this.favoriteUsers[username] ? this.favoriteUsers[username].isFavorite : false);
    },
    playGameMethod() {
      this.checkGameValidations(false, this.getOpponentDetails.opponentName, this.getOpponentDetails.avatar, this.getGameDescriptionDetails.awayLevel);
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getGameDescriptionDetails',
      'getOpponentDetails',
    ]),
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('users', [
      'favoriteUsers',
    ]),
    roundDetails() {
      return this.getGameDescriptionDetails.roundDtos;
    },
    isGameWinner() {
      return (this.getGameDescriptionDetails.home && (this.getGameDescriptionDetails.homeScore > this.getGameDescriptionDetails.awayScore)) ||
        (!this.getGameDescriptionDetails.home && (this.getGameDescriptionDetails.homeScore < this.getGameDescriptionDetails.awayScore));
    },
    returnCorrectStyle() {
      return 'modal'.concat(' modal--postgame ').concat((this.getGameDescriptionDetails.home && this.isGameWinner) ||
           (!this.getGameDescriptionDetails.home && !this.isGameWinner) ? 'player1' : 'player2');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ScoreDescription.vue